export const WRONG_OTP = 'ERROR_VALIDATING_TOKEN';
